import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-user",
  "use": "icon-icon-user-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"icon-icon-user\"><ellipse cx=\"512\" cy=\"300\" rx=\"300\" ry=\"300\" /><path d=\"M -1.221 1021.192 L 1022.113 1023.776 C 754.907 490.019 284.214 499.115 -1.221 1021.192 Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol